
import { Options } from "vue-class-component";
import ComponentConfigMixins from "../ComponentConfigMixins";

@Options({
    name: "flowable-common-form-components-post-picker-config",
})
export default class PostPickerConfig extends ComponentConfigMixins {}
